(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/prescript.js'); 
'use strict';

svs.player_login = svs.player_login || {};

svs.player_login.app = new Backbone.Marionette.Application({
  region: '#mainRegion',

  onStart: function() {
    svs.player_login.logger = new svs.core.log.Logger('module:player_login');
    svs.player_login.router = new svs.player_login.Router();
    Backbone.history.start({ pushState: true, root: svs.core.data.baseUrl });
  }
});

svs.player_login.views = svs.player_login.views || {};
svs.player_login.views.poker = svs.player_login.views.poker || {};
svs.player_login.views.bankid = svs.player_login.views.bankid || {};
svs.player_login.views.freja = svs.player_login.views.freja || {};
svs.player_login.views.loginChecks = svs.player_login.views.loginChecks || {};
svs.player_login.behaviors = svs.player_login.behaviors || {};
svs.player_login.utils = svs.player_login.utils || {};
svs.player_login.models = svs.player_login.models || {};

 })(window);